<template>
  <div class="jps-stats jps-static">
    <BaseContainerSpread>
      <UiPageHeader
        class="title"
        :title="{
          ja: '現在のデータ',
          en: 'Statistics',
        }"
        icon="koicon/koicon-34"
      />
    </BaseContainerSpread>

    <BaseContainerSpread
      tag="div"
      v-if="categoryCount && databases && organizations"
    >
      <div class="jps-static-main">
        <div class="jps-static-content">
          <section class="jps-top-about">
            <div class="level">
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading is-size-6">
                    {{ lss('連携データベース数', '# of Databases') }}
                  </p>
                  <a href="#databases" class="num is-size-4">{{
                      num(dbCount)
                    }}</a>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading is-size-6">
                    {{ lss('連携機関数', '# of Organizations') }}
                  </p>
                  <a href="#organizations" class="num is-size-4">{{
                    num(orgCount)
                  }}</a>
                </div>
              </div>
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading is-size-6">
                    {{ lss('メタデータ件数', '# of Metadata') }}
                  </p>
                  <BaseLink :to="`/csearch/${systemCrossSearchId()}?csid=${systemCrossSearchId()}&from=` + 0" class="num is-size-4">
                    {{ num(itemCount) }}
                  </BaseLink>
                </div>
              </div>
            </div>
            <template v-if="Object.keys(categoryCount).length">
              <h3 class="title has-text-centered">
                <span class="is-size-5-desktop is-size-5-touch">
                  {{
                    lss('分野毎のデータ件数', 'Number of records by each area')
                  }}
                </span>
              </h3>
              <UiStatsCategoryTable :categoryCount="categoryCount" />
            </template>
          </section>
        </div>
      </div>

      <template v-if="databases">
        <h3 class="title has-text-centered" id="databases">
          <span class="is-size-5-desktop is-size-5-touch">
            {{ lss('連携データベース一覧', 'Database List') }}
          </span>
        </h3>
        <UiStatsDatabaseTable :databases="databases" />
      </template>

      <template v-if="organizations">
        <h3 class="title has-text-centered" id="organizations">
          <span class="is-size-5-desktop is-size-5-touch">
            {{ lss('連携機関一覧', 'Organization List') }}
          </span>
        </h3>
        <UiStatsOrganizationTable :organizations="organizations" />
      </template>
    </BaseContainerSpread>
    <div v-else class="stats-loading">
      <div class="jps-logo-icon jps-loading" />
    </div>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  disableDefaultMargin: {
    top: true,
  },
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)

const { lss, num } = useI18n()

const { searchDatabase } = useDatabase()
let result = await searchDatabase({
  size: 500,
  sort: ['name.yomi.sort:asc'],
})
const dbCount = result.hit
const databases = result.list

const { searchOrganization } = useOrganization()
result = await searchOrganization({
  size: 500,
  sort: ['name.yomi.sort:asc'],
})
const organizations = result.list
const orgCount = result.hit

const { getSearchId } = useItem()
result = await getSearchId(systemCrossSearchId())({
  size: 0,
})
const itemCount = result.hit
const categoryCount = result.facets.find(f => f.key === 'cm')?.counts || {}
</script>

<style lang="scss">
.jps-stats {
  .jps-static-main {
    .jps-static-content {
      .media {
        margin-top: 0rem;
        padding-top: 0;
        /* box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12); */
      }
    }
  }

  .title {
    margin-top: 2rem;
  }
  .jps-responsive-table {
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2rem;
    margin-bottom: 2rem;
    td {
      vertical-align: middle;
    }
    .jps-srt-count {
      width: 6rem;
    }
    .jps-srt-api {
      width: 7.5rem;
    }
  }
  .stats-loading {
    min-height: calc(100vh - 3.5rem - 220px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
